import { render, staticRenderFns } from "./CaptureWebCam.vue?vue&type=template&id=33a972b8&scoped=true&"
import script from "./CaptureWebCam.vue?vue&type=script&lang=js&"
export * from "./CaptureWebCam.vue?vue&type=script&lang=js&"
import style0 from "./CaptureWebCam.vue?vue&type=style&index=0&id=33a972b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a972b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33a972b8')) {
      api.createRecord('33a972b8', component.options)
    } else {
      api.reload('33a972b8', component.options)
    }
    module.hot.accept("./CaptureWebCam.vue?vue&type=template&id=33a972b8&scoped=true&", function () {
      api.rerender('33a972b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Packages/Captures/components/CaptureWebCam.vue"
export default component.exports